import { render, staticRenderFns } from "./SideNavLink.vue?vue&type=template&id=d464d010&"
import script from "./SideNavLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideNavLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SideNavLink.vue?vue&type=style&index=0&id=d464d010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports